import { CollabSkillRepository } from '../repositories/CollabSkillRepository'
import { AllocateCollabSkillsUseCase } from '../use_cases/AllocateCollabSkillsUseCase'

export function makeAllocateCollabSkills() {
  const repository = new CollabSkillRepository()
  return new AllocateCollabSkillsUseCase(repository)
}
